import axiosInstance, { axiosInstanceV2 } from '../axios';

export const fetchOnboardingMe = async () => {
	try {
		const token = localStorage.getItem('authToken');
		const response = await axiosInstance.get('/auth/me/onboarding', {
			headers: {
				Authorization: token,
			},
		});

		return response.data;
	} catch (error) {
		if (error.response) {
			return {
				success: false,
				status: error.response.status,
				message: error.response.data?.message || 'Failed to fetch onboarding status',
			};
		}
		return {
			success: false,
			status: 0,
			message: 'Network error. Please try again.',
		};
	}
};

export const sendUserOTP = async (email, purpose = 'EMAIL_VERIFICATION', verifyEmail = true) => {
	try {
		const response = await axiosInstance.post('/auth/send-otp', {
			email,
			verifyEmail,
			purpose,
		});
		return response.data;
	} catch (error) {
		if (error.response) {
			return {
				success: false,
				status: error.response.status,
				message: error.response.data?.message || 'Failed to send OTP',
			};
		}
		return {
			success: false,
			status: 0,
			message: 'Network error. Please try again.',
		};
	}
};

export const verifyOTP = async (params) => {
	try {
		const response = await axiosInstance.post(
			`/auth/verify-otp?verify_email=${params.verify_email}`,
			params,
		);

		return response.data;
	} catch (error) {
		if (error.response) {
			return {
				success: false,
				status: error.response.status,
				message: error.response.data?.message || 'OTP verification failed',
			};
		}
		return {
			success: false,
			status: 0,
			message: 'Network error. Please try again.',
		};
	}
};

export const login = async (params) => {
	try {
		const response = await axiosInstance.post('/auth/login', params);
		return response.data;
	} catch (error) {
		if (error.response) {
			return {
				success: false,
				status: error.response.status,
				message: error.response.data?.message || 'Login failed. Please check your credentials.',
			};
		}

		return {
			success: false,
			status: 0,
			message: 'Network error. Please try again.',
		};
	}
};

export const signup = async (params) => {
	try {
		const response = await axiosInstance.post('/auth/signup', params);
		return response.data;
	} catch (error) {
		if (error.response) {
			return {
				success: false,
				status: error.response.status,
				message: error.response.data?.message || 'Signup failed. Please try again.',
			};
		}

		return {
			success: false,
			status: 0,
			message: 'Network error. Please try again.',
		};
	}
};
export const sessionContinue = async () => {
	// axios.post(url, data, config) — the object was previously passed in the
	// DATA slot, so `{ headers: ... }` was sent as the request BODY and no
	// Authorization header was ever set. The backend reads
	// `req.body.refreshToken || req.cookies.refreshToken`, so this only worked
	// by falling back to the cookie.
	const refreshToken = localStorage.getItem('refreshToken');

	const response = await axiosInstance.post(
		'/auth/refresh-token',
		refreshToken ? { refreshToken } : {},
		{ headers: { 'Content-Type': 'application/json' } },
	);

	return response.data;
};

export const fetchOrganisationBranding = async (subDomain) => {
	try {
		const res = await axiosInstanceV2.get(`/settings/organisation/branding/${subDomain}`);
		return res.data;
	} catch (error) {
		if (error.response) {
			return {
				success: false,
				status: error.response.status,
				message: error.response.data?.message || 'Signup failed. Please try again.',
			};
		}

		return {
			success: false,
			status: 0,
			message: 'Network error. Please try again.',
		};
	}
};

export const fetchSsoSession = async (subdomain) => {
	try {
		const url = subdomain
			? `/auth/sso-session?subdomain=${encodeURIComponent(subdomain)}`
			: '/auth/sso-session';
		const response = await axiosInstance.get(url, {
			withCredentials: true,
		});
		return response.data;
	} catch (error) {
		return {
			success: false,
			authenticated: false,
			explicitLogout: error?.response?.data?.authenticated === false || error?.response?.status === 401,
			message: error?.response?.data?.message || 'Failed to check SSO session',
		};
	}
};

export const logoutUser = async () => {
	try {
		await axiosInstance.post('/auth/logout', {}, { withCredentials: true });
	} catch (error) {
		console.error('Logout error:', error);
	}
};
